import { isMobileDevice } from '_metronic/assets/ts/_utils'
import React from 'react'
import { useFormik } from 'formik'
import * as Yup from 'yup'

const validationSchema = Yup.object({
	width: Yup.number()
		.required('Width is required')
		.positive('Width must be a positive number')
		.min(1, 'Width must be at least 1 cm'),
	length: Yup.number()
		.required('Length is required')
		.positive('Length must be a positive number')
		.min(1, 'Length must be at least 1 cm'),
	height: Yup.number()
		.required('Height is required')
		.positive('Height must be a positive number')
		.min(1, 'Height must be at least 1 cm'),
	material: Yup.string().required('Material is required'),
	thickness: Yup.number()
		.required('Thinkness is required')
		.positive('Thinkness must more than 0')
		.min(1, 'Height must be at least 1 mm'),
	quantity: Yup.number().required('Quantity is required'),
})

const Characteristics: React.FC = () => {
	const formik = useFormik({
		initialValues: {
			width: '',
			length: '',
			height: '',
			material: '',
			thickness: '',
			quantity: '',
		},
		validationSchema,
		onSubmit: values => {
			console.log('Form data:', values)
		},
	})
	return (
		<div className="card border border-kumopack-grey-200">
			<div className="card-header border-0 mt-4">
				<div className="card-title">
					{/* Title */}
					<div>
						<h4 className="text-kumopack-grey-900 fw-bold mb-2">2. คุณลักษณะของสินค้า</h4>
						<div className="text-kumopack-grey-600 fs-6">แบรนด์ สี ขนาด ประเภท</div>
					</div>
				</div>
				<div className="mt-2 separator border-1px w-100 border-kumopack-grey-200"></div>
			</div>

			<div className={`mb-5 d-flex flex-column flex-xl-row`}>
				<div className="card-body">
					<div className={`mb-5 d-flex flex-column flex-xl-row`}>
						<div className="col-12 col-xl-12">
							<div className="row g-5">
								<div className="col-12 col-xl-12">
									<div className="row gy-5">
										<label
											className={`form-label col-12 col-xl-3 mb-0 d-flex flex-row mb-3`}
											data-testid="form-input-label-component">
											<div className="d-flex flex-column">
												<span>ขนาดสินค้า</span>
												<span className="text-kumopack-grey-600 fs-7">(กว้าง x ยาว x สูง)</span>
											</div>
										</label>
										<div className="col-12 col-xl-3">
											<form className="mb-5">
												<div
													className={`form-group position-relative ${
														!isMobileDevice() ? 'form-horizontal' : ''
													}`}>
													<input
														id="product-width"
														name="width"
														type="text"
														placeholder="กว้าง"
														className={`form-control ${
															formik.touched.width && formik.errors.width ? 'is-invalid' : ''
														}`}
														onChange={formik.handleChange}
														onBlur={formik.handleBlur}
														value={formik.values.width}
													/>
													<span
														className={`form-unit ${
															formik.touched.width && formik.errors.width ? 'd-none' : ''
														}`}>
														cm
													</span>
													{formik.touched.width && formik.errors.width ? (
														<div className="invalid-feedback">{formik.errors.width}</div>
													) : null}
												</div>
											</form>
										</div>
										<div className="col-12 col-xl-3">
											<form className="mb-5">
												<div
													className={`form-group position-relative ${
														!isMobileDevice() ? 'form-horizontal' : ''
													}`}>
													<input
														id="product-length"
														name="length"
														type="text"
														placeholder="ยาว"
														className={`form-control ${
															formik.touched.length && formik.errors.length ? 'is-invalid' : ''
														}`}
														onChange={formik.handleChange}
														onBlur={formik.handleBlur}
														value={formik.values.length}
													/>
													<span
														className={`form-unit ${
															formik.touched.length && formik.errors.length ? 'd-none' : ''
														}`}>
														cm
													</span>
													{formik.touched.length && formik.errors.length ? (
														<div className="invalid-feedback">{formik.errors.length}</div>
													) : null}
												</div>
											</form>
										</div>
										<div className="col-12 col-xl-3">
											<form className="mb-5">
												<div
													className={`form-group position-relative ${
														!isMobileDevice() ? 'form-horizontal' : ''
													}`}>
													<input
														id="product-height"
														name="height"
														type="text"
														placeholder="สูง"
														className={`form-control ${
															formik.touched.height && formik.errors.height ? 'is-invalid' : ''
														}`}
														onChange={formik.handleChange}
														onBlur={formik.handleBlur}
														value={formik.values.height}
													/>
													<span
														className={`form-unit ${
															formik.touched.height && formik.errors.height ? 'd-none' : ''
														}`}>
														cm
													</span>
													{formik.touched.height && formik.errors.width ? (
														<div className="invalid-feedback">{formik.errors.height}</div>
													) : null}
												</div>
											</form>
										</div>
									</div>
								</div>
							</div>
							<div className="row g-5">
								<div className="col-12 col-xl-12">
									<div className="row gy-5">
										<label
											className={`form-label col-12 col-xl-3 mb-0 d-flex flex-row mb-3`}
											data-testid="form-input-label-component">
											<div className="d-flex flex-column">
												<span>Material</span>
											</div>
										</label>
										<div className="col-12 col-xl-9">
											<form className="mb-5">
												<div
													className={`form-group position-relative ${
														!isMobileDevice() ? 'form-horizontal' : ''
													}`}>
													<input
														id="product-material"
														name="material"
														type="text"
														className={`form-control ${
															formik.touched.material && formik.errors.material ? 'is-invalid' : ''
														}`}
														onChange={formik.handleChange}
														onBlur={formik.handleBlur}
														value={formik.values.material}
													/>
													{formik.touched.material && formik.errors.material ? (
														<div className="invalid-feedback">{formik.errors.material}</div>
													) : null}
												</div>
											</form>
										</div>
									</div>
								</div>
								<div className="col-12 col-xl-12">
									<div className="row gy-5">
										<label
											className={`form-label col-12 col-xl-3 mb-0 d-flex flex-row mb-3`}
											data-testid="form-input-label-component">
											<div className="d-flex flex-column">
												<span>ความหนาของผลิตภัณฑ์</span>
											</div>
										</label>
										<div className="col-12 col-xl-9">
											<form className="mb-5">
												<div
													className={`form-group position-relative ${
														!isMobileDevice() ? 'form-horizontal' : ''
													}`}>
													<input
														id="product-material"
														name="thickness"
														type="text"
														className={`form-control ${
															formik.touched.thickness && formik.errors.thickness
																? 'is-invalid'
																: ''
														}`}
														onChange={formik.handleChange}
														onBlur={formik.handleBlur}
														value={formik.values.thickness}
													/>
													<span
														className={`form-unit ${
															formik.touched.thickness && formik.errors.thickness ? 'd-none' : ''
														}`}>
														mm
													</span>
													{formik.touched.thickness && formik.errors.thickness ? (
														<div className="invalid-feedback">{formik.errors.thickness}</div>
													) : null}
												</div>
											</form>
										</div>
									</div>
								</div>
								<div className="col-12 col-xl-12">
									<div className="row gy-5">
										<label
											className={`form-label col-12 col-xl-3 mb-0 d-flex flex-row mb-3`}
											data-testid="form-input-label-component">
											<div className="d-flex flex-column">
												<span>จำนวนสินค้าต่อแพ๊ค</span>
											</div>
										</label>
										<div className="col-12 col-xl-9">
											<form className="mb-5">
												<div
													className={`form-group position-relative ${
														!isMobileDevice() ? 'form-horizontal' : ''
													}`}>
													<input
														id="product-material"
														name="quantity"
														type="text"
														className={`form-control ${
															formik.touched.quantity && formik.errors.quantity ? 'is-invalid' : ''
														}`}
														onChange={formik.handleChange}
														onBlur={formik.handleBlur}
														value={formik.values.quantity}
													/>
													<span
														className={`form-unit ${
															formik.touched.quantity && formik.errors.quantity ? 'd-none' : ''
														}`}>
														ชิ้น
													</span>
													{formik.touched.quantity && formik.errors.quantity ? (
														<div className="invalid-feedback">{formik.errors.quantity}</div>
													) : null}
												</div>
											</form>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

export default Characteristics
